import { Observable } from 'rxjs'
import { BeneficiarySoaSubmitDetail } from '../models/submit-soa-model'

export abstract class SOAFormSubmissionGateWay {
    abstract sendEmail(submitSoaModel: BeneficiarySoaSubmitDetail): Observable<boolean>
}
